<template>
	<div>
		<div class="flex gap-4 items-center">
			<EvaluationLevelColorPicker v-model="level.color" :class="[!isValidColor && markInvalidInputs ? 'ring-4 ring-offset-1 ring-red-300' : '']" />
			<input type="text" v-model="name" ref="enli" class="input input-bordered w-full" :class="[!isValidName && markInvalidInputs ? 'input-error bg-red-50' : '']" />
		</div>
	</div>
</template>


<script lang="ts">
import EvaluationLevelColorPicker from '@/components/EvaluationLevelColorPicker.vue';
import { EvaluationLevel } from '@/models/EvaluationLevel.model';

export default {
	emits: ['update:modelValue'],

	props: {
		level: {
			type: Object, // { id: string, name: string, color: string, position: number }
			required: true,
		},
		markInvalidInputs: {
			type: Boolean,
			default: false,
		},
	},

	components: {
		EvaluationLevelColorPicker,
	},

	mounted() {
		this.$refs.enli.focus();

		// Calculate the i18n key map
		const messages = this.$i18n.messages[this.$i18n.locale];

		this.i18nKeyMap = {};
		for (const key in messages) {

			// Key must be prefixed.
			if (!key.startsWith(EvaluationLevel.i18nPrefix)) {
				continue;
			}

			// Check if the value is a translation key
			this.i18nKeyMap[messages[key]] = '$' + key.substring(EvaluationLevel.i18nPrefix.length);
		}
	},

	data() {
		return {
			i18nKeyMap: {} as {
				[key: string]: string
			},
		};
	},

	computed: {
		isValidName() {
			return this.level.name.length > 0;
		},
		isValidColor() {
			return this.level.color.length > 0 && this.level.color.match(/^#[0-9A-F]{6}$/i);
		},

		name: {
			get() {
				if (this.level.nameTranslationKey) {
					return this.$t(this.level.nameTranslationKey);
				}
				return this.level.name;
			},
			set(value: string) {

				// Look in the translation messages to find if any key matches the value
				// If it does, set the nameTranslationKey to that key

				if (typeof(this.i18nKeyMap[value]) !== 'undefined') {
					this.level.name = this.i18nKeyMap[value];
					return;
				}

				// Nothing found, set the name to the value
				this.level.name = value;


			}
		}
	},

	watch: {
		level: {
			deep: true,
			handler() {
				this.$emit('update:modelValue', this.level);
			}
		}
	},
}
</script>